import { msg } from "@omegagrid/localize";
import { NodeSource, TreeOptions, TreeSource } from "@omegagrid/tree";
import { BrowserAdapter } from "@reporting/rp-app-host";
import { MODULE_CODES } from "@reporting/rp-types/accounting";

export class AgingBrowserAdapter extends BrowserAdapter {

	constructor() { super() }

	async getTree(): Promise<TreeSource> {
		const treeItems: NodeSource[] = [];
		treeItems.push({
			k: `definition-dimensions-${MODULE_CODES.AGING}`,
			v: msg('Dimensions'),
			l: 0,
			icon: { icon: ['fas', 'cube'], color: '#2CA155' }
		}, {
			k: 'definition-attributes-agingDetail',
			v: `${msg('Detail')} - ${msg('Attributes')}`,
			l: 0,
			icon: { icon: 'brackets-curly', color: 'GoldenRod' }
		}, {
			k: `definition-drillColumns-${MODULE_CODES.AGING}`,
			v: `${msg('Detail')} - ${msg('Columns')}`,
			l: 0,
			icon: { icon: 'table-list', color: 'DarkGreen' }
		}, {
			k: `definition-securityRoles-${MODULE_CODES.AGING}`,
			v: msg('Security roles'),
			l: 0,
			icon: { icon: 'lock-keyhole', color: 'DarkSlateBlue' },
		});
		return treeItems;
	}

	getOptions(): Partial<TreeOptions> {
		return {
			selectMode: 'none',
			expanders: false,
		};
	}
}
